export default __webpack_public_path__ + "static/media/Alert.1a97c535.svg";